<app-header></app-header>
<div class="container mt20">
    <div class="row">
        <div *ngFor="let cat of categoriesData; let i= index">
            <div class="col-xs-4 mt10">
                <a [routerLink]="['/game-play/', cat.id]">
                    <img src="{{cat.gameIcon}}" alt="" class="round-corner" width="100%">
                </a>
                <div class="game-title mt10">{{cat.title}}</div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>